import type { IconButtonProps } from '@hover/blueprint';
import { forwardRef, transition } from '@hover/blueprint';
import { iArrowLeft, iArrowRight } from '@hover/icons';
import React from 'react';

import { IconButton } from 'src/shared/components';

export interface CarouselArrowProps extends Partial<IconButtonProps> {
  direction: 'next' | 'previous';
  shouldShow: boolean;
}

const CarouselArrow = forwardRef<CarouselArrowProps, 'button'>(
  ({ direction, shouldShow, ...props }, ref) => {
    const isPrevious = direction === 'previous';

    const outside = `translate(${isPrevious ? '-50%' : '50%'}, -50%)`;
    const inside = 'translate(0, -50%)';

    return (
      <IconButton
        {...transition.easing250('transform', 'opacity')}
        display={{ base: 'none', tablet: 'flex' }}
        icon={isPrevious ? iArrowLeft : iArrowRight}
        justifyContent="center"
        label={direction}
        opacity={shouldShow ? 1 : 0}
        ref={ref}
        transform={shouldShow ? inside : outside}
        {...props}
      />
    );
  },
);

export { CarouselArrow };
